export const baseURL = process.env.REACT_APP_BASEURL || 'http://localhost:3000';

// oidc configuration
export const oidc = {
    clientId: 'cloud-entry',
    redirectUri: `${baseURL}/callback`,
    silentRedirectUri: `${baseURL}/silent-renew.html`,
    postLogoutRedirectUri: baseURL
};



// WEBPACK FOOTER //
// ./src/Appconfig.ts